// extracted by mini-css-extract-plugin
export default {"serverErrorView":"ServerErrorView_serverErrorView__WkDsW"};